// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Card, CardBody } from '../../../../components/card/card.jsx';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { cleanAssignmentListById, GetAssignmentById } from '../../../../store/HR/Person/assignmentSlice.js';
import { Link, useParams } from 'react-router-dom';
import AssignmentForm from './AssignmentForm.jsx';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';
import useAssignmentData from '../../../../hooks/HR/useAssignmentData.js';

const Assignment = () => {
  const { id } = useParams();
  const {
    isLoading,
    error2,
    Data,
    Grade,
    Group,
    Organization,
    Jobs,
    Position,
    Payroll,
    Locations,
    SuperVisor,
    Status,
    allAssignment
  } = useAssignmentData(id);

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const { AssignmentListById, loading, error } = useSelector(state => state.Assignments);

  const currentId = allAssignment?.find(item => item.isCurrent)?.id || '';

  const sortedList = allAssignment?.slice().sort((a, b) => {
    const dateA = new Date(a.startDate);
    const dateB = new Date(b.startDate);
    return dateA - dateB;
  });

  useEffect(() => {
    if (allAssignment?.length) {
      dispatch(GetAssignmentById(currentId));
    }
    return () => {
      dispatch(cleanAssignmentListById());
    };
  }, [dispatch, currentId]);

  //______________________________________________________________________________________________________
  // تهيئة القيمة الافتراضية ل أكتيف

  const [active, setActive] = useState();
  useEffect(() => {
    if (allAssignment?.length > 0) {
      setActive(allAssignment?.find(f => f.isCurrent === true).id);
    }
  }, [allAssignment]);

  //________________________________________________________________________________________________
  const handlebutton = async item => {
    dispatch(cleanAssignmentListById());
    dispatch(GetAssignmentById(item.id));
    setActive(item.id);
  };
  //____________________________________

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: ':moduleHome'
          },
          {
            name: t('Employees'),
            link: '/HR/Employees'
          },
          {
            name: t('Employee Aassignment'),
            link: null
          }
        ]}
        PageName={t('Employee Aassignment')}
        subtitle={i18n.language === 'en' ? Data.name : Data.name2}
      />

      <div className='row'>
        <div className='col-xl-12'>
          <Card>
            <Loading loading={loading || isLoading} error={error || error2}>
              <>
                <div className='mb-2 '>
                  <Card>
                    <CardBody>
                      <div style={{ direction: 'ltr' }} className='nav-wizards-container'>
                        <nav className='nav nav-wizards-2 mb-3'>
                          {Object.keys(Data)?.length
                            ? sortedList?.map(item => (
                                <div key={item.id} className='nav-item col '>
                                  <Link
                                    className={`nav-link ${active === item.id ? 'active' : ''}`}
                                    onClick={() => handlebutton(item)}
                                  >
                                    <div className={`nav-text d-flex justify-content-around `}>
                                      {item.isCurrent && (
                                        <span className=' badge    text-black  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center '>
                                          {t('CurrentAssignment')}
                                          <i className='fa fa-clock fs-15px fa-fw me-5px'></i>
                                        </span>
                                      )}
                                      {item.startDate}
                                    </div>
                                  </Link>
                                </div>
                              ))
                            : ''}
                        </nav>
                      </div>
                    </CardBody>
                  </Card>
                </div>
                
                {/* <div className='mb-2'>
                  <div className='d-flex flex-nowrap overflow-auto pb-3'>
                    {Object.keys(Data)?.length
                      ? sortedList?.map(item => (
                          <div key={item.id} className='flex-shrink-0 me-3'>
                            <Card>
                              <div
                                className={`card cursor-pointer ${active === item.id ? 'border-primary shadow' : ''}`}
                                onClick={() => handlebutton(item)}
                                style={{ width: '200px', transition: 'all 0.3s ease' }}
                              >
                                <div className='card-body text-center'>
                                  <h5 className='card-title'>{item.startDate}</h5>
                                  {item.isCurrent && (
                                    <span className='badge bg-warning text-dark'>
                                      {t('CurrentAssignment')}
                                      <i className='fas fa-clock ms-1'></i>
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Card>
                          </div>
                        ))
                      : ''}
                  </div>
                </div> */}

                {/* <div className='mb-4'>
                  <div className='row'>
                    {Object.keys(Data)?.length
                      ? sortedList?.map(item => (
                          <div key={item.id} className='col-lg-3 col-md-4 mb-3'>
                            <Card>
                              <div
                                className={`card h-100 cursor-pointer ${
                                  active === item.id ? 'border-primary shadow' : ''
                                }`}
                                onClick={() => handlebutton(item)}
                                style={{ transition: 'all 0.3s ease' }}
                              >
                                <div className='card-body'>
                                  <div className='d-flex justify-content-between align-items-center'>
                                    <h5 className='card-title mb-0'>{item.startDate}</h5>
                                    {item.isCurrent && (
                                      <span className='badge bg-warning text-dark'>
                                        {t('CurrentAssignment')}
                                        <i className='fas fa-clock ms-1'></i>
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className='card-footer bg-transparent'>
                                  <small className='text-muted'>انقر لعرض التفاصيل</small>
                                </div>
                              </div>
                            </Card>
                          </div>
                        ))
                      : ''}
                  </div>
                </div> */}

                

                <CardBody>
                  {Object.keys(Data)?.length
                    ? (Object.keys(AssignmentListById)?.length > 0 || allAssignment?.length === 0) && (
                        <AssignmentForm
                          AssignmentListById={AssignmentListById}
                          Data={Data}
                          Grade={Grade}
                          Group={Group}
                          Jobs={Jobs}
                          Locations={Locations}
                          Organization={Organization}
                          Payroll={Payroll}
                          Position={Position}
                          Status={Status}
                          SuperVisor={SuperVisor}
                          allAssignment={allAssignment}
                        />
                      )
                    : ''}
                </CardBody>
              </>
            </Loading>
          </Card>
        </div>
      </div>

      <div />
    </>
  );
};

export default Assignment;
